<template>
  <div class="password-login">
    <headerBack></headerBack>
    <div class="content">
      <verification
        title="登录"
        agreementText="绑定即代表同意"
        btnName="登录"
        loginType="password"
        smsType="5"
        @callSubmit="submit"
      ></verification>
      <div class="row">
        <span @click="toCodeLogin">验证码登录</span>
        <span @click="toForget">忘记密码？</span>
      </div>
    </div>
  </div>
</template>

<script>
import headerBack from "@/components/common/headerBack.vue";
import verification from "@/components/login/verification.vue";
import userApi from "@/api/userApi";
import accountApi from "@/api/accountApi";
import popupConfirm from "@/components/popupcom/popupConfirm.vue";
import { setToken, setUserId, AESEncrypted } from "@/libs/util";

export default {
  data() {
    return {
      popupConfirmStatus: false,
      // bindToken: "",
      inviteCode: "",
      loginType: "login"
    };
  },
  mounted() {
    // this.bindToken = this.$route.query.bind_token;
    this.inviteCode = this.$route.query.invitation_code;
    this.loginType = this.$route.query.loginType;
    // 2026-10-22：被禁用账号在其它页面被踢回登录页时，javaAxios 会把提示语暂存到
    // sessionStorage（整页跳转会冲掉原本的 toast），这里取出来展示一次。
    const blockedMsg = window.sessionStorage.getItem("loginBlockedMsg");
    if (blockedMsg) {
      window.sessionStorage.removeItem("loginBlockedMsg");
      this.$toast(blockedMsg);
    }
  },
  components: {
    headerBack,
    verification,
    popupConfirm
  },
  methods: {
    submit(phone, password) {
      const ciphertext = AESEncrypted(password);
      let data = {
        phone: phone,
        password: ciphertext
      };
      userApi
        .loginPWD(data)
        .then(res => {
          if (res.user_id != undefined) {
            setUserId(res.user_id);
            setToken(res.token);
            this.$store.commit("setUserObj", {
              phone: res.phone,
              realname: res.realname,
              user_id: res.user_id,
              user_type_name: res.user_type_name,
              user_type: res.user_type
            });

            // 获取用户银行卡信息
            accountApi.accountBank().then(resp => {
              if (resp.id !== undefined) {
                this.$store.commit("setAccountBankObj", resp);
              }
            });

            // 记录登录账号
            window.localStorage.setItem("loginPhone", phone);
            this.$router.push({
              name: "myUserHome"
            });
          }
        })
        .catch(res => {
          const resp = res.data;
          console.log(resp);
        });
    },
    toCodeLogin() {
      this.$router.push({
        name: "codeLogin"
      });
    },
    toForget() {
      this.$router.push({
        name: "forget"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.row {
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-size: 12px;
    color: #666666;
  }
}
</style>
